export default "__VITE_ASSET__k7pO_Fv7__"